import { render, staticRenderFns } from "./ProspectBrowse.vue?vue&type=template&id=6d923b30"
import script from "./ProspectBrowse.vue?vue&type=script&lang=ts"
export * from "./ProspectBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d923b30')) {
      api.createRecord('6d923b30', component.options)
    } else {
      api.reload('6d923b30', component.options)
    }
    module.hot.accept("./ProspectBrowse.vue?vue&type=template&id=6d923b30", function () {
      api.rerender('6d923b30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contacts/ProspectBrowse.vue"
export default component.exports